import React from 'react';
import PublicPageShell from './PublicPageShell';

export default function TermsScreen() {
  return (
    <PublicPageShell title="Terms of Service" updated="September 4, 2026">
      <p>
        These Terms of Service ("Terms") govern your use of Grove — Family
        Ops Hub, available at <strong>grove.mcschaef.family</strong>{' '}
        ("Grove," "we," "us"). By signing in or otherwise using Grove, you
        agree to these Terms. If you don't agree, please don't use the app.
      </p>

      <h2>1. What Grove is</h2>
      <p>
        Grove is a family logistics tool that helps households coordinate
        calendars, caregivers, and household reference information. It is
        offered as-is, currently free of charge, and is not a substitute for
        emergency services, medical advice, or legal recordkeeping.
      </p>

      <h2>2. Accounts &amp; access</h2>
      <ul>
        <li>
          Grove account owners sign in with Google. You're responsible for
          keeping your Google account secure — Grove relies on Google
          Sign-In and does not separately store passwords.
        </li>
        <li>
          Account owners may invite caregivers (e.g. co-parents,
          grandparents, sitters) via email or a share link, and control what
          each caregiver can see (schedule, kid info, house info, emergency
          contacts).
        </li>
        <li>
          You're responsible for the accuracy of information you enter and
          for managing who you grant access to. Revoke a caregiver's access
          at any time from within the app.
        </li>
      </ul>

      <h2>3. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>use Grove for any unlawful purpose, or to store information you don't have the right to share;</li>
        <li>attempt to access another family's data, or share your access with someone the account owner hasn't authorized;</li>
        <li>interfere with or disrupt Grove's operation, or attempt to reverse-engineer or circumvent its access controls;</li>
        <li>use Grove to make decisions where a delay, error, or outage could put someone's safety at risk (e.g. as a sole emergency-contact system).</li>
      </ul>

      <h2>4. Your content</h2>
      <p>
        You retain ownership of the family, calendar, and household
        information you enter into Grove ("your content"). You grant Grove
        a limited license to store and display your content solely to
        operate the app for you and the caregivers you authorize. You're
        responsible for having the right to share any information you enter
        about other people, including children in your care.
      </p>

      <h2>5. Third-party services</h2>
      <p>
        Grove integrates with Google services (Sign-In and Calendar) to
        function. Your use of those services is also subject to Google's
        own terms and privacy policy. Grove is not responsible for the
        availability or behavior of third-party services it depends on.
      </p>

      <h2>6. Availability &amp; changes</h2>
      <p>
        Grove is provided on an "as is" and "as available" basis, without
        warranties of any kind, express or implied, including
        merchantability, fitness for a particular purpose, or
        non-infringement. We may modify, suspend, or discontinue any part of
        Grove at any time, and we don't guarantee uninterrupted or
        error-free operation.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, Grove and its operator will
        not be liable for any indirect, incidental, special, or
        consequential damages, or for any loss of data, arising from your
        use of, or inability to use, the app. Grove is a household
        coordination tool, not a safety-critical or emergency system —
        always maintain your own emergency contacts and records outside the
        app.
      </p>

      <h2>8. Termination</h2>
      <p>
        You may stop using Grove and request deletion of your account at any
        time. We may suspend or terminate access to Grove for anyone who
        violates these Terms or misuses the service.
      </p>

      <h2>9. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. If we make material
        changes, we'll update the "last updated" date above. Continued use
        of Grove after changes are posted means you accept the revised
        Terms.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions about these Terms? Contact{' '}
        <a href="mailto:adreck.mcdonald@gmail.com">adreck.mcdonald@gmail.com</a>.
      </p>
    </PublicPageShell>
  );
}
